import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { IListItem, IResultViewType } from '@pro/activity/testerClub/interface';
import styles from './index.module.less';
import Iconfont from '@base/lib/Iconfont';
import cn from 'classnames';
import ModalContent from '@pro/activity/testerClub/ResultsContent/idnex';

type IProps = {
    product: IListItem
    open?: boolean;
    onClose: () => void;
    viewType?: IResultViewType;
}

const ResultsModal: React.FC<IProps> = (props) => {

    const {
        open,
        onClose,
        product,
        viewType,
    } = props


    return (
        <Modal
            className={styles['modal-wrap']}
            destroyOnClose
            width={'542px'}
            centered
            open={open}
            onCancel={onClose}
            footer={false}
            closeIcon={<Iconfont className={cn(styles['close-icon'], 'icon-x')}/>}
        >
            <div
                id='js-results-content'
                className={styles['content-wrap']}
            >
                <ModalContent product={product} viewType={viewType}/>
            </div>

        </Modal>
    );
};

export default ResultsModal